import App from './App';
import { renderHublessNav } from './core/strategies/renderHublessNav';
new App().start(renderHublessNav);